export default "__VITE_ASSET__CUVRfQZ1__"